import styled from 'styled-components';

export const DashboardItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1;
`;

export const DashboardOnboardingContainer = styled.div<{
  isOnboardingGadgetOpened: boolean;
}>`
  width: ${({ isOnboardingGadgetOpened }) =>
    isOnboardingGadgetOpened ? '350px' : '0px'};
  padding-right: 16px;
`;

export const DashboardItemsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const DashboardItem = styled.div`
  min-width: 400px;
  max-width: 800px;
  padding: 16px;
  flex-basis: 100%;
`;
